import { createMemo } from "solid-js";

/**
 * @typedef {object} UICheckboxProps
 * @property {boolean} [checked] - Whether the box is ticked
 * @property {string | import('solid-js').JSX.Element} [label] - Text beside the box
 * @property {'xs' | 'sm' | 'md' | 'lg'} [size='md'] - Control size
 * @property {boolean} [disabled] - Whether the control is read-only
 * @property {(checked: boolean) => void} [onChange] - Called with the new state
 * @property {string} [className] - Additional classes for the wrapping label
 */

const SIZE_CLASSES = Object.freeze({
  xs: "tw:d-checkbox-xs",
  sm: "tw:d-checkbox-sm",
  md: "tw:d-checkbox-md",
  lg: "tw:d-checkbox-lg",
});

const LABEL_SIZE_CLASSES = Object.freeze({
  xs: "tw:text-meta",
  sm: "tw:text-dense",
  md: "tw:text-dense",
  lg: "tw:text-body",
});

/**
 * A labelled checkbox.
 * @param {UICheckboxProps} props Component props
 * @returns {import('solid-js').JSX.Element} Checkbox
 */
export function UICheckbox(props) {
  const classes = createMemo(() =>
    ["tw:d-checkbox", SIZE_CLASSES[props.size || "md"]].join(" "),
  );

  return (
    <label
      className={`tw:flex tw:cursor-pointer tw:items-center tw:gap-2 ${props.className || ""}`}
    >
      <input
        type="checkbox"
        className={classes()}
        checked={!!props.checked}
        disabled={props.disabled}
        onChange={(e) => props.onChange?.(e.target.checked)}
      />
      {props.label && (
        <span className={LABEL_SIZE_CLASSES[props.size || "md"]}>
          {props.label}
        </span>
      )}
    </label>
  );
}
